const isProduction = process.env.NODE_ENV === 'production';

export const logger = {
  log: (...args) => {
    if (!isProduction) {
      console.log(...args); // eslint-disable-line no-console
    }
  },

  warn: (...args) => {
    if (!isProduction) {
      console.warn(...args);
    }
  },

  error: (...args) => {
    // normal errors
    console.error(...args);
  },
};